export { OnscreenKeyboardKey, type OnscreenKeyboardKeyProps } from "#onscreen-keyboard-key";
export { onscreenKeyboardKeyBorderClassName } from "#onscreen-keyboard-key-border-class-name";
